import * as React from 'react';
const SvgTreeVertical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M9 12h4c0 .57.03.92.16 1.18.14.28.37.51.66.66.32.16.74.16 1.58.16h1.2c.84 0 1.26 0 1.58-.16.28-.14.51-.37.66-.66.16-.32.16-.74.16-1.58v-1.2c0-.84 0-1.26-.16-1.58-.14-.28-.37-.51-.66-.66C17.86 8 17.44 8 16.6 8h-1.2c-.84 0-1.26 0-1.58.16-.28.14-.51.37-.66.66-.13.26-.16.61-.16 1.18H9V8c.57 0 .92-.03 1.18-.16.28-.14.51-.37.66-.66.16-.32.16-.74.16-1.58V4.4c0-.84 0-1.26-.16-1.58-.14-.28-.37-.51-.66-.66C9.86 2 9.44 2 8.6 2H7.4c-.84 0-1.26 0-1.58.16-.28.14-.51.37-.66.66C5 3.14 5 3.56 5 4.4v1.2c0 .84 0 1.26.16 1.58.14.28.37.51.66.66.26.13.61.16 1.18.16v9.6c0 .84 0 1.26.16 1.58.14.28.37.51.66.66.18.09.4.13.71.15.23.01.51.01.88.01h3.6c0 .57.03.92.16 1.18.14.28.37.51.66.66.32.16.74.16 1.58.16h1.2c.84 0 1.26 0 1.58-.16.28-.14.51-.37.66-.66.16-.32.16-.74.16-1.58v-1.2c0-.84 0-1.26-.16-1.58-.14-.28-.37-.51-.66-.66-.32-.16-.74-.16-1.58-.16h-1.2c-.84 0-1.26 0-1.58.16-.28.14-.51.37-.66.66-.13.26-.16.61-.16 1.18h-4v-6zm6-1.6V10h2v2h-2v-1.6m0 8V18h2v2h-2v-1.6m-8-14V4h2v2H7V4.4"
    />
  </svg>
);
export default SvgTreeVertical;
